import type { ChatBadgeCountRes } from '@/api/user-dashboard/queries';
import { UserRole } from '@/stores/slices/selected-user-config';

export const getContextChatUnreadCount = (
  data: ChatBadgeCountRes | undefined,
  role: UserRole,
  entityId: string | null,
): number => {
  if (!data) return 0;

  switch (role) {
    case 'user':
      return data.user ?? 0;

    case 'admin':
      return data.gamma ?? 0;

    case 'entity': {
      if (!entityId) return 0;

      return (data.entities ?? []).find((entity) => entity.entityId === entityId)?.count ?? 0;
    }

    default:
      return 0;
  }
};
